"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
export interface BundeslandStats {
  bundesland: string;
  active_offering_count: number;
  min_price: string | null;
  max_price: string | null;
  naturraum_count: number;
  last_offering_activity: string | null;
  last_deal_date: string | null;
}
export function useBundeslandStats(bundesland) {
  const $ = _c(6);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(!!bundesland);
  let t0;
  let t1;
  if ($[0] !== bundesland) {
    t0 = () => {
      if (!bundesland) {
        return;
      }
      const controller = new AbortController();
      fetch(`/api/marketplace/bundesland-stats?bundesland=${encodeURIComponent(bundesland)}`, {
        signal: controller.signal
      }).then(_temp).then(json => {
        const data = json.data?.[0] ?? null;
        setStats(data);
      }).catch(_temp2).finally(() => setLoading(false));
      return () => controller.abort();
    };
    t1 = [bundesland];
    $[0] = bundesland;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== loading || $[4] !== stats) {
    t2 = {
      stats,
      loading
    };
    $[3] = loading;
    $[4] = stats;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
function _temp2(err) {
  if (err.name !== "AbortError") {
    console.error("Failed to fetch bundesland stats:", err);
  }
}
function _temp(res) {
  return res.json();
}